import { render } from "./monthCardDesc.vue?vue&type=template&id=7227d8ce&scoped=true"
import script from "./monthCardDesc.vue?vue&type=script&lang=js"
export * from "./monthCardDesc.vue?vue&type=script&lang=js"

import "./monthCardDesc.vue?vue&type=style&index=0&id=7227d8ce&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7227d8ce"]])

export default __exports__